import type { EditableProcessStatusKey } from "./types";

/**
 * Os status que a pessoa escolhe para um processo, na ordem do seletor.
 *
 * TUT-472 (Q034) — a lista vivia escrita à mão em dois lugares: o "Editar
 * processo" oferecia "Arquivado" e o filtro da lista não, então um processo
 * arquivado não tinha como ser encontrado pelo status. Lista única, lida pelo
 * diálogo, pelo filtro e pelo `validateSearch` de `/processos`.
 */
/**
 * TUT-567 — o rótulo do processo inativado (o status `ARCHIVED`/`archived`), de
 * um ponto só: o seletor do "Editar processo", o filtro da lista, o Kanban, o
 * selo da página do processo e o modo demonstração leem esta constante. A API
 * diz a mesma palavra em `presenters/comum.ts` (`ROTULO_DO_PROCESSO_INATIVO`).
 */
export const ROTULO_DO_PROCESSO_INATIVO = "Inativo";

/** O processo inativo não aceita novo agendamento (perícia, prazo…): a frase do botão travado e do aviso. */
export const FRASE_DO_PROCESSO_INATIVO_NAO_AGENDA =
  "Processo inativo: não aceita novo agendamento. Para voltar a agendar, mude o status para Ativo.";

/** O processo está inativo (o status `archived`)? Um ponto só, para a página, a escolha do processo e as abas. */
export function processoInativo(status: { key: string }): boolean {
  return status.key === "archived";
}

export const opcoesDeStatusDoProcesso: ReadonlyArray<{
  value: EditableProcessStatusKey;
  label: string;
}> = [
  { value: "analysis", label: "Em análise" },
  { value: "expertise_scheduled", label: "Perícia agendada" },
  { value: "awaiting_documents", label: "Aguardando documentos" },
  { value: "completed", label: "Concluído" },
  { value: "archived", label: ROTULO_DO_PROCESSO_INATIVO },
];

export function isStatusDoProcesso(
  valor: string,
): valor is EditableProcessStatusKey {
  return opcoesDeStatusDoProcesso.some((opcao) => opcao.value === valor);
}
